import type { FunctionComponent } from "react";

import { withUserServiceEnvironment } from "scmp-app/components/content/content-reaction/hoc";

import { useContentReactionActionRedirect } from "./hooks";

const Component: FunctionComponent = () => {
  useContentReactionActionRedirect();
  return null;
};

Component.displayName = "ContentReactionActionRedirect";
export const ContentReactionActionRedirect = withUserServiceEnvironment(Component);
